import { atom } from 'jotai';

export const userProfileModalAtom = atom<{
  visible: boolean;
  userId: number | null;
}>({
  visible: false,
  userId: null,
});